import React from 'react';
import {Form, FormCheck} from 'react-bootstrap';

import styles from './ToggleFacet.module.css';

const ToggleFacet = (props) => {
    return (
        <Form.Group className="mb-3">
            <FormCheck>
                <FormCheck.Input className={styles.toggleFacetInput} onChange={props.onChange} />
                <FormCheck.Label className={styles.toggleFacetLabel} >{props.label}</FormCheck.Label>
            </FormCheck>
        </Form.Group>
    );
};

export default ToggleFacet;